<template>
    <div class="make-section">
      <div class="make-content">
        <h2 class="recibe-style">¿Qué recibirás (según perfil)?</h2>
        <div class="row spacing-make">
          <div class="col-md-6 spacing-col">
            <img src="../../../src/assets/img/Group 59.png" alt="Papá icono" class="icon-diagnosis" />
            <p class="description-make">
              <b>Papá</b>: Recibe gratis el test "¿Estás acompañando o presionando a tu hijo?" 
              y descubre, sin juicios, cómo es tu estilo de apoyo.
              <br>
              <br>
              Te ayudará a ver si estás en sintonía con lo que tu hijo realmente necesita 
              en este momento de su vida.
            </p>
          </div>
          <div class="col-md-6 spacing-col">
            <img src="../../../src/assets/img/Group 60.png" alt="Hijo icono" class="icon-diagnosis" />
            <p class="description-make">
              <b>Hijo</b>: Recibe gratis el test: Descubre qué tipo de carreras probablemente no van 
              contigo, según tu forma de ser y lo que realmente te importa.
              <br>
              <br>
              Un primer paso ligero pero revelador para empezar a aclarar tu camino sin presión.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="description-our-make">
              Lo que recibirás no solo es un reporte. Es un punto de partida para transformar la relación con tu hijo y construir, juntos, un camino con sentido.
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MakeDiagnosisSection'
  }
  </script>

<style>
    .make-section {
        width: 100%;
        height: 900px;
        background-color: #0F2030;
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        box-sizing: border-box;
    }
    
    .make-content {
        display: flex;
        max-height: 1440px;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        text-align: center;
    }

    @media (max-width: 768px) {
  .make-section {
    height: auto;
    min-height: 320px;
    background-color: #0F2030 !important;
    padding: 10px 0;
    align-items: flex-start;
  }
  .make-content {
    max-height: none;
    gap: 14px;
    padding: 0 2vw;
  }
  .recibe-style {
    font-size: 1.1rem;
    padding: 12px 4vw 8px 4vw;
    margin-bottom: 0;
    word-break: break-word;
    line-height: 1.2;
  }
  .row.spacing-make {
    flex-direction: column !important;
    gap: 0 !important;
    width: 100%;
  }
  .col-md-6.spacing-col {
    width: 100% !important;
    padding: 10px 0;
  }
  .icon-diagnosis {
    width: 64px !important;
    height: 64px !important;
    margin-bottom: 10px !important;
  }
  .description-make,
  .description-our-make {
    font-size: 1rem !important;
    padding: 0 2vw !important;
    line-height: 1.3 !important;
    word-break: break-word !important;
  }
}
  </style>